module.exports = __webpack_public_path__ + "img/portfolio13.9c25cddb.jpg";